import type { CSSProperties } from "react";
import type { CharacterAvatarSize, CharacterPortraitLayout } from "../../models/ICharacter";
import { getCharacterPortraitTokens } from "./CharacterTokens";

export function getCharacterPortraitCssVars(size: CharacterAvatarSize, layout: CharacterPortraitLayout): CSSProperties {
    const tokens = getCharacterPortraitTokens(size, layout);

    return {
        ["--cp-avatar-diameter" as any]: `${tokens.avatar.diameterPx}px`,
        ["--cp-avatar-ring" as any]: `${tokens.avatar.ringPx}px`,
        ["--cp-badge-diameter" as any]: `${tokens.avatar.badgeDiameterPx}px`,
        ["--cp-badge-ring" as any]: `${tokens.avatar.badgeRingPx}px`,
        ["--cp-badge-offset" as any]: `${tokens.avatar.badgeOffsetPx}px`,

        ["--cp-name-size" as any]: tokens.text.namePx ? `${tokens.text.namePx}px` : undefined,
        ["--cp-subtitle-size" as any]: tokens.text.subtitlePx ? `${tokens.text.subtitlePx}px` : undefined,
        ["--cp-stat-size" as any]: tokens.text.statPx ? `${tokens.text.statPx}px` : undefined,

        ["--cp-avatar-to-name" as any]: `${tokens.spacing.avatarToNamePx}px`,
        ["--cp-name-to-subtitle" as any]: `${tokens.spacing.nameToSubtitlePx}px`,
        ["--cp-subtitle-to-stats" as any]: `${tokens.spacing.subtitleToStatsPx}px`,
    };
}
